import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const InventorySetupApi = createApi({
  reducerPath: "InventorySetup",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND2_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getAllCategories: builder.query({
      query: (val) => {
        const page = val.page ?? 1;
        const limit = val.limit ?? 10;
        const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
        const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
        const search = val.search ? `&search=${val.search}` : "";
        if (!limit && !page) {
          return "/v1/categories";
        }
        return `/v1/categories?page=${page}&limit=${limit}${search}${sortBy}${sortOrder}`;
      },
    }),
    getCategoriesList: builder.query({
      query: () => "/v1/categories",
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `/v1/categories/${id}`,
        method: "DELETE",
      }),
    }),
    createCategory: builder.mutation({
      query: (data) => ({
        url: `/v1/categories`,
        method: "POST",
        body: data,
      }),
    }),
    editCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/v1/categories/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getAllSubCategories: builder.query({
      query: (val) => {
        const page = val.page ?? 1;
        const limit = val.limit ?? 10;
        const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
        const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
        const search = val.search ? `&search=${val.search}` : "";

        if (limit && page) {
          return `/v1/subcategories?limit=${limit}&page=${page}${search}${sortBy}${sortOrder}`;
        } else {
          return "/v1/subcategories";
        }
      },
    }),
    getSpecificSubCategory: builder.query({
      query: (id) => `/v1/subcategories/${id}`,
    }),
    addSubCategory: builder.mutation({
      query: (data) => ({
        url: `/v1/subcategories`,
        method: "POST",
        body: data,
      }),
    }),
    deleteSubCategory: builder.mutation({
      query: (id) => ({
        url: `/v1/subcategories/${id}`,
        method: "DELETE",
      }),
    }),
    editSubCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/v1/subcategories/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getAllParts: builder.query({
      query: (val) => {
        const page = val.page ?? 1;
        const limit = val.limit ?? 10;
        const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
        const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
        const search = val.search ? `&search=${val.search}` : "";

        if (limit && page) {
          return `/v1/parts?limit=${limit}&page=${page}${search}${sortBy}${sortOrder}`;
        } else {
          return "/v1/parts";
        }
      },
    }),
    deletePart: builder.mutation({
      query: (id) => ({
        url: `/v1/parts/${id}`,
        method: "DELETE",
      }),
    }),
    getSubCategoriesList: builder.query({
      query: (id) => `/v1/categories/${id}`,
    }),
    addPart: builder.mutation({
      query: (data) => ({
        url: `/v1/parts`,
        method: "POST",
        body: data,
      }),
    }),
    editPart: builder.mutation({
      query: ({ id, data }) => ({
        url: `/v1/parts/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetAllCategoriesQuery,
  useDeleteCategoryMutation,
  useCreateCategoryMutation,
  useEditCategoryMutation,
  useGetAllSubCategoriesQuery,
  useGetSpecificSubCategoryQuery,
  useDeleteSubCategoryMutation,
  useAddSubCategoryMutation,
  useEditSubCategoryMutation,
  useGetCategoriesListQuery,
  useGetAllPartsQuery,
  useDeletePartMutation,
  useGetSubCategoriesListQuery,
  useAddPartMutation,
  useEditPartMutation,
} = InventorySetupApi;
